export default __webpack_public_path__ + "static/media/check_in.940cb5c0.svg";